import { api } from "../lib/api";

export interface InvitationValidationResponse {
	valid: boolean;
	providerName?: string;
	patientName?: string;
	patientEmail?: string;
	signupUrl?: string;
	error?: string;
}

/**
 * Validates an invitation token by calling the era-api backend
 * @param token The invitation token from the QR code URL
 * @returns Validation response with provider details and signup URL
 */
export async function validateInvitationToken(
	token: string,
): Promise<InvitationValidationResponse> {
	try {
		const response = await api.post<InvitationValidationResponse>(
			"/api/invitation/validate-token",
			{ token },
			{
				// @ts-expect-error - skipAuth is a custom property for public endpoints
				skipAuth: true,
			},
		);

		return response.data as InvitationValidationResponse;
	} catch (error) {
		console.error("Error validating invitation token:", error);
		return {
			valid: false,
			error:
				error instanceof Error
					? error.message
					: "Failed to validate invitation token",
		};
	}
}
